import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Errors } from '@atlas/ui';

import { getIsFieldRequired } from 'common/utils';

export default function Field(props) {
  const { children, className, options } = props;

  const { errors, rules, touched } = options;

  const isRequiredSymbol = getIsFieldRequired(rules);

  const fieldClassName = cx(
    'field',
    {
      // 'field-touched': touched,
      // 'field-filled': filled,
      // 'field-error': touched && filled && (Array.isArray(errors) && errors.length > 0),
      // 'field-active': active,
      // 'field-disabled': disabled,
      required: isRequiredSymbol,
    },
    className,
  );

  // Mapping errors & applying label params using field ruleOption
  const fieldErrors = React.useMemo(() => {
    if (touched && Array.isArray(errors)) {
      return errors.map(({ message, ruleOption }) => ({
        message,
        params: { ruleOption },
      }));
    }
  }, [touched, errors]);

  return (
    <div className={fieldClassName}>
      {children}

      <Errors errors={fieldErrors} />
    </div>
  );
}

Field.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  options: PropTypes.object.isRequired,
};
